import { Injectable } from '@angular/core';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';

@Injectable()
export class ErrorDialogService {
	private opened = false;

	constructor(private readonly dialogService: NxDialogService) {}

	openDialog(businessError: any): void {
		if (!this.opened) {
			this.opened = true;
			var componentDialogRef: NxModalRef<ErrorDialogComponent> = this.dialogService.open( ErrorDialogComponent,{ariaLabel: '', showCloseIcon: true, data: businessError},);

			componentDialogRef.afterClosed().subscribe(() => {
				this.opened = false;
			});
		
		}
	}
}
